﻿export function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result.split(',')[1]); // Remove metadata
      } else {
        reader.onloadend = null;
        reader.onerror = null;
        reject(new Error('Der opstod en fejl under konverteringen af lydfilen.'));
      }
    };
    reader.onerror = error => {
      reader.onloadend = null;
      reader.onerror = null;
      reject(error);
    };

    reader.readAsDataURL(blob);
  });
}
